const type = 'SET_TRANSACTIONS_LOADING';

const setTransactionsLoading = (data) => ({
  data,
  type,
});

export { type };
export default setTransactionsLoading;
